export enum ShotsRoutes {
  AggCollection = 'agg-collection',
  AggMatches = 'agg-matches',
  ArchiveByDates = 'archive-by-dates',
  ArchiveByHashes = 'archive-by-hashes',
  ArchiveByList = 'archive-by-list',
  ArchiveByMachine = 'archive-by-machine',
  ArchiveById = 'archive-by-id',
  CountCollection = 'count-collection',
  GetLastShot = 'get-last-shot',
  GetMatches = 'get-matches',
  HashCollection = 'hash-collection',
  HashDebug = 'hash-debug',
  UpdateShot = 'update-shot',
}
